module.exports = __webpack_public_path__ + "static/media/RA-KV0404B.670b7766.png";